import React from "react";
import { CgSpinner } from "react-icons/cg";

const LoadingWithLable = ({ className, text }) => {
  return (
    <div
      className={`flex justify-center items-center gap-3 mt-5 w-full text-black ${className}`}
    >
      <p className="">{text || 'LOADING'}</p>
      <CgSpinner className="animate-spin " />
    </div>
  );
};

export default LoadingWithLable;
